// Specific permission label mapping
const PERMISSION_LABELS = {
  'viewPaymentCards:Users': 'Can view user payment cards',
  'deletePaymentCard:Users': 'Can delete user payment cards',
  'adjustBalance:Users': 'Can adjust user balance',
  'toggleActivation:Users': 'Can toggle user activation',
  'initiateConnection:OcpiIntegration': 'Can initiate ocpi connection',
  'viewOngoingSessions:Users': 'Can view user ongoing sessions',
  'editEmail:Users': 'Can edit user email',
  'viewNotifications:Users': 'Can view user notifications',
}

export const formatPermissionName = (action, subject) => {
  const key = `${action}:${subject}`
  if (PERMISSION_LABELS[key]) return PERMISSION_LABELS[key]

  // Split camelCase action
  const formattedAction = action.replace(/([A-Z])/g, ' $1').toLowerCase()

  // Split camelCase subject
  const formattedSubject = subject.replace(/([A-Z])/g, ' $1').toLowerCase()

  return `Can ${formattedAction} ${formattedSubject}`.trim()
}

export const permissionKey = ({ action, subject }) => `${action}:${subject}`
